export const directBookingsSettingsView = {
  loading: "Cargando configuración…",

  sidebar: {
    brandTitle: "Anuncios",
    brandSub: "Panel de configuración",
    searchPlaceholder: "Buscar…",
    generalLabel: "General",
    servicesName: "Servicios y experiencias",
    servicesSub: "Una lista para toda la cuenta",
    promotionsName: "Promociones",
    promotionsSub: "Crear · Editar · Gestionar",
    globalChip: "GLOBAL",
    inactivePrefix: "Inactivo · {type}",
    unitsCount: "{count} unidad | {count} unidades",
    empty: "Sin propiedades.",
    listingFallbackName: "Anuncio",
  },

  status: {
    active: "Activo",
    inactive: "Inactivo",
  },

  card: {
    unsavedChanges: "Cambios sin guardar",
  },

  share: {
    title: "Enlace de reserva directa",
    hintPrefix: "Comparte el enlace de",
    hintSuffix: "para recibir reservas sin comisiones.",
    copyTitle: "Copiar enlace",
    viewAsVisitor: "Ver como visitante",
    copied: "Enlace copiado.",
    copyError: "No se pudo copiar el enlace.",
    whatsappText: "Hola 👋 Te comparto el enlace para reservar: {link}",
  },

  savebar: {
    unsaved: "Cambios sin guardar",
    noChanges: "Sin cambios pendientes",
    saving: "Guardando…",
  },

  drawer: {
    close: "Cerrar",
  },

  content: {
    selectListing: "Selecciona un anuncio",
  },

  units: {
    pickerHint: "Activa o desactiva la visibilidad de cada unidad en la reserva directa, o entra a configurarla (tarifas, imágenes, descripción, servicios y cargos).",
    visible: "Visible",
    hidden: "Oculta",
    showTooltip: "Mostrar esta unidad en la reserva directa",
    configure: "Configurar",
  },

  header: {
    listingSub: "Anuncio · {count} unidad · reservas directas | Anuncio · {count} unidades · reservas directas",
    unitSub: "Unidad · configuración individual",
    unitSubCoded: "Unidad {code} · configuración individual",
    hotelSub: "Hotel / Camping · reservas directas",
    apartmentSub: "Apartamento / Villa · reservas directas",
  },

  tabs: {
    reservations:       { label: "Visibilidad del anuncio", sub: "Actívalo y configura pago y aprobación en la reserva directa" },
    units_list:         { label: "Unidades",                sub: "Qué unidades se pueden reservar" },
    common_images:      { label: "Zonas comunes",           sub: "Fotos comunes del edificio (portada)" },
    rate_plans:         { label: "Tarifas",                 sub: "Planes de tarifa visibles" },
    images:             { label: "Imágenes",                sub: "Galería del anuncio" },
    description:        { label: "Descripción",             sub: "Texto y detalles del anuncio" },
    services:           { label: "Servicios",               sub: "Servicios y equipamiento" },
    promotions:         { label: "Promociones",             sub: "Cómo se muestran en este anuncio" },
    addons:             { label: "Ocupación",               sub: "Descuentos y huésped extra" },
    age_rules:          { label: "Reglas de huéspedes",     sub: "Bebés, niños y capacidad" },
    additional_charges: { label: "Cargos e impuestos",      sub: "IVA, limpieza y cargos" },
    web_embed:          { label: "Integración web",         sub: "Pon el buscador en tu propia web" },
  },

  save: {
    ratePlans: "Guardar tarifas",
    promotions: "Guardar promociones",
    addons: "Guardar cargos",
    ageRules: "Guardar reglas",
    additionalCharges: "Guardar cargos e impuestos",
    payments: "Guardar pagos",
    default: "Guardar",
  },

  types: {
    apartment: "Apartamento",
    house: "Casa",
    villa: "Villa",
    loft: "Loft",
    room: "Habitación",
    studio: "Estudio",
    cabin: "Cabaña",
    hotel: "Hotel",
    hostel: "Hostal",
    camping: "Camping",
  },

  toasts: {
    unitVisible: "Unidad visible en la reserva directa.",
    unitHidden: "Unidad oculta.",
    unitUpdateError: "No se pudo actualizar la unidad.",
  },

  errors: {
    noUserUuid: "No se encontró UUID del usuario.",
    loadPage: "No se pudo cargar la página.",
    loadContext: "No se pudo cargar el contexto.",
    saveExec: "No se pudo ejecutar el guardado.",
    saveGeneric: "No se pudo guardar.",
  },

  misc: {
    propertyFallback: "Propiedad {id}",
  },
};
